import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1300. 受注案件メンバー削除
 * [DELETE] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/sales_order_members/:sales_order_member_id
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  sales_order_member_id: number;
};

const destroySalesOrderMember = (props: Props) => {
  return axios.delete(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/sales_order_members/${props.sales_order_member_id}`
  );
};

export const useDestroySalesOrderMember = () => {
  return useMutation({
    mutationFn: destroySalesOrderMember
  });
};